/**
 * XSTRONG POWER Service Management Status System
 * New 9-status pipeline for service management
 */
import { ClipboardList, Search, Clock, Wrench, CheckCircle2, RefreshCw, Package, Star, XCircle } from "lucide-react";

export const SERVICE_PIPELINE = [
  { status: "Received",               emoji: "📋", icon: ClipboardList, dot: "#64748b", bg: "bg-slate-100",  text: "text-slate-700",   border: "border-slate-200",  desc: "Service entry received" },
  { status: "Under Inspection",        emoji: "🔍", icon: Search,       dot: "#2563eb", bg: "bg-blue-50",   text: "text-blue-800",    border: "border-blue-200",   desc: "Device being inspected" },
  { status: "Waiting for Approval",    emoji: "⏳", icon: Clock,        dot: "#d97706", bg: "bg-amber-50",  text: "text-amber-800",   border: "border-amber-200",  desc: "Awaiting customer/admin approval" },
  { status: "Repair in Progress",      emoji: "🔧", icon: Wrench,       dot: "#ea580c", bg: "bg-orange-50", text: "text-orange-800",  border: "border-orange-200", desc: "Repair underway" },
  { status: "Repaired",                emoji: "✅", icon: CheckCircle2, dot: "#059669", bg: "bg-emerald-50",text: "text-emerald-800", border: "border-emerald-200",desc: "Repair complete" },
  { status: "Replacement Approved",    emoji: "🔄", icon: RefreshCw,    dot: "#7c3aed", bg: "bg-purple-50", text: "text-purple-800",  border: "border-purple-200", desc: "Replacement unit approved" },
  { status: "Replacement Dispatched",  emoji: "📦", icon: Package,      dot: "#4f46e5", bg: "bg-indigo-50", text: "text-indigo-800",  border: "border-indigo-200", desc: "Replacement dispatched" },
  { status: "Completed",               emoji: "🎉", icon: Star,         dot: "#16a34a", bg: "bg-green-50",  text: "text-green-800",   border: "border-green-200",  desc: "Service completed" },
  { status: "Warranty Rejected",       emoji: "❌", icon: XCircle,      dot: "#e11d48", bg: "bg-rose-50",   text: "text-rose-800",    border: "border-rose-200",   desc: "Warranty claim rejected" },
];

// Legacy statuses for backward compat (old jobs)
const LEGACY_MAP = {
  "Pick Up Request":   "Received",
  "Pick Up Accepted":  "Received",
  "Barcode Generated": "Received",
  "Picked Up":         "Received",
  "In Transit":        "Received",
  "Repairing":         "Repair in Progress",
  "In Repair":         "Repair in Progress",
  "In Dispatch":       "Replacement Dispatched",
  "Out for Delivery":  "Replacement Dispatched",
  "Delivered":         "Completed",
};

export const ALL_SERVICE_STATUSES = SERVICE_PIPELINE.map(s => s.status);

export const getServiceStep = (status) => {
  const direct = SERVICE_PIPELINE.find(s => s.status === status);
  if (direct) return direct;
  const mapped = LEGACY_MAP[status];
  return SERVICE_PIPELINE.find(s => s.status === mapped) || SERVICE_PIPELINE[0];
};

export const ServiceStatusBadge = ({ status, size = "sm" }) => {
  const step = getServiceStep(status);
  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full font-medium border ${
      size === "lg" ? "text-sm px-3.5 py-1.5" : "text-xs px-2.5 py-0.5"
    } ${step.bg} ${step.text} ${step.border}`}>
      <span>{step.emoji}</span>
      {status}
    </span>
  );
};

// Connector types
export const CONNECTOR_TYPES = [
  "Type 1 (J1772)",
  "Type 2 (Mennekes)",
  "CCS Type 1",
  "CCS Type 2",
  "CHAdeMO",
  "GB/T (Chinese)",
  "3-Pin Socket",
  "Bharat AC-001",
  "Bharat DC-001",
  "Other",
];

// Warranty statuses
export const WARRANTY_OPTIONS = [
  "Under Warranty",
  "Out of Warranty",
  "Warranty Expired",
  "Warranty Voided",
];

// Service types
export const SERVICE_TYPES = [
  "Repair",
  "Replacement",
  "Inspection",
  "Warranty Claim",
  "Preventive Maintenance",
  "Software Update",
];

// Common charger models
export const CHARGER_MODELS = [
  "XSTRONG XS-3.3",
  "XSTRONG XS-7.2",
  "XSTRONG XS-11",
  "XSTRONG XS-22",
  "XSTRONG XS-DC30",
  "XSTRONG XS-DC60",
  "Other",
];

// Voltage options
export const VOLTAGE_OPTIONS = ["48V","54.6V","58.4V","60V","67.2V","69.3V","71.2V","73V","84V","96V","120V","144V","230V","Other"];

// Ampere options  
export const AMPERE_OPTIONS = ["3A","5A","6A","8A","10A","13A","16A","20A","25A","32A","40A","63A","Other"];
